import React from 'react'
import BrainIcon from '../../icons/BrainIcon'
import { ConvElem } from './ConvElem';

export const Conversation = ({list,classes,onClick}) => {
   console.log(list);
  return (
    <div>{
         Array.isArray(list) ?  list?.map( ( el,index )=>
         (
            <ConvElem key={el.id}  el={el}  
            onClick={onClick} 
            classes={classes}>  
            <BrainIcon className={classes.icon_test} /> 
            </ConvElem>
         
         )
         
         )
         :''
   }
   </div>
  )
}
